/**
 * Confetti en canvas (adaptado de conffetiAnimation): dos explosiones centradas en la pantalla.
 * Usa requestAnimationFrame; llamar stopBookUpgradeConfetti al desmontar la vista.
 */

const rand = (min, max) => Math.random() * (max - min) + min;

const confettiParams = {
    /** Por explosión (cada lado); hay 2 explosiones → total 2× este valor */
    number: 42,
    /** Tamaño base de la letra en px (cada partícula elige uno al azar) */
    fontSize: [11, 24],
    size: { x: [14, 28], y: [14, 28] },
    initSpeed: 17,
    gravity: 0.46,
    drag: 0.08,
    terminalVelocity: 4.2,
    flipSpeed: 0.012,
    spawnLiftRatio: 0.12,
};

const colors = [
    { front: '#3B870A', back: '#235106' },
    { front: '#B96300', back: '#6f3b00' },
    { front: '#E23D34', back: '#88251f' },
    { front: '#CD3168', back: '#7b1d3e' },
    { front: '#664E8B', back: '#3d2f53' },
    { front: '#394F78', back: '#222f48' },
    { front: '#008A8A', back: '#005353' },
];

const BASE_LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
const UMLAUT_LETTERS = 'ÄÖÜäöü';
const UMLAUT_COPIES = 5;
const ALPHABET = BASE_LETTERS + UMLAUT_LETTERS.repeat(UMLAUT_COPIES);

let confetti = null;
let confettiCtx = null;
let container = { w: 0, h: 0 };
let confettiElements = [];
let clickPosition = [0, 0];
let rafId = null;

function Conf() {
    this.randomModifier = rand(-1, 1);
    this.colorPair = colors[Math.floor(rand(0, colors.length))];
    this.letter = ALPHABET[Math.floor(rand(0, ALPHABET.length))];
    this.baseFont = rand(confettiParams.fontSize[0], confettiParams.fontSize[1]);
    this.dimensions = {
        x: rand(confettiParams.size.x[0], confettiParams.size.x[1]),
        y: rand(confettiParams.size.y[0], confettiParams.size.y[1]),
    };
    this.position = {
        x: clickPosition[0],
        y: clickPosition[1],
    };
    this.rotation = rand(0, 2 * Math.PI);
    this.scale = { x: 1, y: 1 };
    this.velocity = {
        x: rand(-confettiParams.initSpeed, confettiParams.initSpeed) * 0.4,
        y: rand(-confettiParams.initSpeed, confettiParams.initSpeed),
    };
    this.flipSpeed = rand(0.2, 1.5) * confettiParams.flipSpeed;

    if (this.position.y <= container.h) {
        this.velocity.y = -Math.abs(this.velocity.y);
    }

    this.terminalVelocity = rand(1, 1.5) * confettiParams.terminalVelocity;

    this.update = function () {
        this.velocity.x *= 0.98;
        this.position.x += this.velocity.x;

        this.velocity.y += this.randomModifier * confettiParams.drag;
        this.velocity.y += confettiParams.gravity;
        this.velocity.y = Math.min(this.velocity.y, this.terminalVelocity);
        this.position.y += this.velocity.y;

        this.scale.y = Math.cos((this.position.y + this.randomModifier) * this.flipSpeed);
        this.color = this.scale.y > 0 ? this.colorPair.front : this.colorPair.back;
    };
}

function setupCanvas(canvasEl) {
    confetti = canvasEl;
    confettiCtx = confetti.getContext('2d');
    container = {
        w: window.innerWidth,
        h: window.innerHeight,
    };
    confetti.width = container.w;
    confetti.height = container.h;
}

function updateConfetti() {
    if (!confettiCtx || !confetti) return;

    confettiCtx.clearRect(0, 0, container.w, container.h);

    confettiElements.forEach((c) => {
        c.update();
        confettiCtx.translate(c.position.x, c.position.y);
        confettiCtx.rotate(c.rotation);
        const baseFont = c.baseFont;
        confettiCtx.font = `700 ${baseFont}px system-ui, "Segoe UI", sans-serif`;
        confettiCtx.textAlign = 'center';
        confettiCtx.textBaseline = 'middle';
        confettiCtx.fillStyle = c.color;
        const sx = (c.dimensions.x * c.scale.x) / baseFont;
        const sy = (c.dimensions.y * c.scale.y) / baseFont;
        confettiCtx.scale(sx, sy);
        confettiCtx.fillText(c.letter, 0, 0);
        confettiCtx.setTransform(1, 0, 0, 1, 0, 0);
    });

    for (let idx = confettiElements.length - 1; idx >= 0; idx--) {
        const c = confettiElements[idx];
        if (
            c.position.y > container.h ||
            c.position.x < -0.5 * container.w ||
            c.position.x > 1.5 * container.w
        ) {
            confettiElements.splice(idx, 1);
        }
    }

    rafId = window.requestAnimationFrame(updateConfetti);
}

function addConfettiAt(clientX, clientY) {
    const liftY = confettiParams.spawnLiftRatio * container.h;
    clickPosition = [clientX, Math.max(0, clientY - liftY)];
    for (let i = 0; i < confettiParams.number; i++) {
        confettiElements.push(new Conf());
    }
}

/**
 * @param {HTMLCanvasElement | null} canvasEl
 */
export function startBookUpgradeConfetti(canvasEl) {
    if (!canvasEl || typeof canvasEl.getContext !== 'function') return;

    stopBookUpgradeConfetti();
    setupCanvas(canvasEl);

    const w = container.w;
    const h = container.h;
    addConfettiAt(w * 0.3, h * 0.48);
    addConfettiAt(w * 0.7, h * 0.48);

    if (rafId != null) {
        window.cancelAnimationFrame(rafId);
        rafId = null;
    }
    rafId = window.requestAnimationFrame(updateConfetti);
}

export function stopBookUpgradeConfetti() {
    if (rafId != null) {
        window.cancelAnimationFrame(rafId);
        rafId = null;
    }
    confettiElements = [];
    if (confettiCtx && confetti) {
        try {
            confettiCtx.clearRect(0, 0, confetti.width, confetti.height);
        } catch (_) {
            /* canvas puede estar desmontado */
        }
    }
    confettiCtx = null;
    confetti = null;
}
